const KEY = 'neon.progress.v1';

const DEFAULTS = {
  unlockedWorlds: ['w1'],
  levels: {
    // "w1.l1": { completed: false, bestDrops: 0, bestVolume: 0 }
  },
  lastPlayed: null, // { worldId, levelId }
};

let cache = null;

export function getProgress() {
  if (cache) return cache;
  try {
    const raw = localStorage.getItem(KEY);
    cache = raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch {
    cache = { ...DEFAULTS };
  }
  return cache;
}

export function saveProgress(patch) {
  const prev = getProgress();
  cache = { ...prev, ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch {
    // ignore
  }
  return cache;
}

export function completeLevel(worldId, levelId, stats) {
  const p = getProgress();
  const key = `${worldId}.${levelId}`;
  const prevStats = p.levels[key] || { completed: false, bestDrops: 0, bestVolume: 0 };
  const newStats = {
    completed: true,
    bestDrops: Math.max(prevStats.bestDrops, stats.drops || 0),
    bestVolume: Math.max(prevStats.bestVolume, stats.volume || 0),
  };
  return saveProgress({
    levels: { ...p.levels, [key]: newStats },
    lastPlayed: { worldId, levelId },
  });
}

export function markPlaying(worldId, levelId) {
  return saveProgress({ lastPlayed: { worldId, levelId } });
}

export function hasProgress() {
  const p = getProgress();
  return Boolean(p.lastPlayed) || Object.keys(p.levels).length > 0;
}

export function isWorldUnlocked(worldId) {
  return getProgress().unlockedWorlds.includes(worldId);
}
